module.exports = __webpack_public_path__ + "assets/img/landing-image.f94125b6.jpg";